import React, { useMemo } from 'react';
import { View } from 'react-native';
import { isEmpty } from 'lodash-es';

//components
import PrimaryButton from '../../../components/PrimaryButton/PrimaryButton';
import { CANDIDATE_PROGRESS_VALUES } from '../../../constants/strengthenQuestionsConstants';
import newMemberAppUrl from '../../../services/newMemberAppUrl';

//styles
import styles from './styles';

const CandidateProgressBar = ({ data = {} }) => {
  const { status, uuid } = data;
  if (isEmpty(data) || status === 'archived' || status == 'hired') {
    return null;
  }
  const progressBarPercent = data.organization_name === 'Connect Pediatrics' ? Math.ceil(80 / 9) : 80 / 8;
  const progress = useMemo(() => {
    const { links_json, resume_file_links, questions, skills } = data;
    let progressPercentage = 20;
    CANDIDATE_PROGRESS_VALUES.forEach((value) => {
      if (value === 'skills' && !isEmpty(skills)) {
        progressPercentage += progressBarPercent;
      } else if (value === 'resume_file_links' && !isEmpty(resume_file_links)) {
        progressPercentage += progressBarPercent;
      } else if (value === 'links_json' && !isEmpty(links_json) && !isEmpty(links_json[0].value)) {
        progressPercentage += progressBarPercent;
      } else if (value === 'diversity_hire' && questions[value]) {
        progressPercentage += progressBarPercent;
      } else if (!isEmpty(questions[value])) {
        progressPercentage += progressBarPercent;
      }
    });
    const totalProgress = Math.min(progressPercentage, 100)
    return totalProgress;
  }, [data]);

  return (
    <View style={styles.strengthenWrapper}>
      <View style={styles.strengthenText}>
        <span>Application Strength</span>
        <span style={{ color: '#0FBC71' }}>{progress}%</span>
      </View>
      <View style={styles.progressBar}>
        <View
          style={[StyleSheet.absoluteFill, { borderRadius: 8, backgroundColor: '#0FBC71', width: `${progress}%` }]}
        />
      </View>
      <View style={styles.strengthenButton}>
        <PrimaryButton
          style={styles.secondaryButton}
          small
          disabled={progress === 100}
          onPress={() => {
            window.open(`${newMemberAppUrl}/strengthen-questions/candidate?uuid=${uuid}`, '_self');
          }}
        >
          Strengthen Application
        </PrimaryButton>
      </View>
    </View>
  );
};

export default CandidateProgressBar;
